import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CoreDataService } from '@app/core/async-services/http/core.data';
import { API } from '@app/core/models';
import { VersionConfigService } from '@app/core/services/version-config';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { LinkPreview } from './interfaces';

@Injectable({
  providedIn: 'root',
})
export class AttachmentHttpService {
  private _urlPrefix = '';
  private _options: API.HttpOptions;

  constructor(
    private _coreDataService: CoreDataService,
    private _versionConfigService: VersionConfigService,
    private _httpClient: HttpClient,
  ) {
    this._versionConfigService.getVersion('attachment').subscribe((prefix) => {
      this._urlPrefix = `${prefix}/attachment`;
    });
    this._options = this._coreDataService.getHttpOptions();
  }

  getDocument(documentId: string): Observable<API.SecureUrlResponse> {
    const encodedDocumentId = encodeURIComponent(documentId);
    return this._coreDataService.get<API.SecureUrlResponse>(
      `${this._urlPrefix}/document/${encodedDocumentId}`,
      this._options,
    );
  }

  getDocumentPutUrl(
    fileName: string,
    contentType: string,
  ): Observable<API.SecureUrlResponse> {
    const encodedFileName = encodeURIComponent(fileName);
    const encodedContentType = encodeURIComponent(contentType);

    return this._coreDataService.get<API.SecureUrlResponse>(
      `${this._urlPrefix}/document-put-url/${encodedFileName}/${encodedContentType}`,
      {},
    );
  }

  putToAmazon(secureUrl: string, blob: Blob): Observable<null> {
    const contentType = blob.type;

    return this._httpClient.put<null>(secureUrl, blob, {
      headers: new HttpHeaders({
        'Content-Type': contentType,
      }),
    });
  }

  getLinkPreview(url: string): Observable<LinkPreview> {
    return this._coreDataService.get<LinkPreview>(
      `${this._urlPrefix}/link-preview/${encodeURIComponent(url)}`,
      this._options,
    );
  }
}
